// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_01fb6","container":"_406b7","row":"_6701a","content":"a569b"};